
import { Component, Ref, Vue } from "vue-property-decorator";

@Component({})
export default class VideoDemo extends Vue{
  pictureCount = 2

  switchPictureCount() {
    if (this.pictureCount === 1) {
      this.pictureCount = 2
    } else {
      this.pictureCount = 1
    }
  }
}
